/** Current user from `GET /me` (same session cookie as admin). */
export function fetchSessionUser() {
  return fetch('/me', { credentials: 'include', cache: 'no-store' }).then((res) => {
    if (res.status === 401) return null;
    if (!res.ok) return null;
    return res.json();
  });
}
